
namespace GeniuzPOS.Administration {

    @Serenity.Decorators.registerClass()
    export class PsFuncKbMapKeyCodeDialog extends Serenity.EntityDialog<PsFuncKbMapKeyCodeRow, any> {
        protected getFormKey() { return PsFuncKbMapKeyCodeForm.formKey; }
        protected getIdProperty() { return PsFuncKbMapKeyCodeRow.idProperty; }
        protected getLocalTextPrefix() { return PsFuncKbMapKeyCodeRow.localTextPrefix; }
        protected getNameProperty() { return PsFuncKbMapKeyCodeRow.nameProperty; }
        protected getService() { return PsFuncKbMapKeyCodeService.baseUrl; }
        protected getDeletePermission() { return PsFuncKbMapKeyCodeRow.deletePermission; }
        protected getInsertPermission() { return PsFuncKbMapKeyCodeRow.insertPermission; }
        protected getUpdatePermission() { return PsFuncKbMapKeyCodeRow.updatePermission; }

        protected form = new PsFuncKbMapKeyCodeForm(this.idPrefix);

    }
}